<template>
    <Link v-if="href" :href="href" class="inline-flex items-center px-4 py-2 bg-gray-light shadow-md rounded font-bold text-xs uppercase focus:outline-none focus:ring-green focus:ring focus:ring-opacity-50 disabled:opacity-25 transition hover:bg-gray">
        <slot></slot>
    </Link>

    <button v-else :type="type" class="inline-flex items-center px-4 py-2 border-0 bg-gray-light shadow-md rounded font-bold text-xs uppercase tracking-widest focus:outline-none focus:ring-green focus:ring focus:ring-opacity-50 disabled:opacity-25 disabled:cursor-not-allowed transition hover:bg-gray">
        <slot></slot>
    </button>
</template>

<script>
    import { Link } from '@inertiajs/inertia-vue3';

    export default {
        props: {
            type: {
                type: String,
                default: 'button',
            },
            href: String,
        },

        components: {
            Link,
        }
    }
</script>